import { useLocation, useNavigate } from "react-router-dom";

export const useGoBack = (fallbackPath: string) => {
	const navigate = useNavigate();
	const { key } = useLocation();

	const isFirstEntry = key === "default";

	return () => {
		if (isFirstEntry) {
			navigate(fallbackPath);
			return;
		}
		navigate(-1);
	};
};
